module.exports = __webpack_public_path__ + "df2ec691.svg";